import { Component, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';

import { types } from '../project-management.component';
import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { userActions } from '@src/store/reducers/userReducer';

import * as _ from 'lodash';
import $ from 'jquery';

@Component({
    selector: 'project-permission',
    template: require('./project-permission.component.html'),
    styles: [require('./project-permission.component.scss')]
})
export class ProjectPermissionComponent implements OnInit, OnDestroy {
    @Input() public set usersAndGroups(value) {
        this._tempPermission = this.deepCopy(value);
        this._usersAndGroups = value;
        const requests = [];
        if (this._usersAndGroups && this._usersAndGroups.length > 0 && this._project) {
            const firstUser = this._usersAndGroups[0];
            const projectId = this._project.id;
            if (this._usersAndGroups.length === 1) {
                this.getUserOrGroup(firstUser.type, firstUser.id, projectId);
            }
            this._usersAndGroups.forEach((item: any, index: any) => {
                if (index === 0) {
                    return;
                }
                switch (item.type) {
                case 'user':
                    requests.push(this.store.dispatch({
                        type: this._project.type === 'proj'
                            ? userActions.GET_USER_ROLES : userActions.GET_PROJECT_GROUP_ROLES,
                        payload: { userId: item.id, projectId: this._project.id }
                    }));
                    break;
                case 'userGroup':
                    requests.push(this.store.dispatch({
                        type: this._project.type === 'proj'
                            ? userActions.GET_USER_GROUP_ROLES : userActions.GET_PROJECT_GROUP_ROLES_BY_USER_GROUP,
                        payload: { userGroupId: item.id, projectId: this._project.id }
                    }));
                    break;
                }
            });
            Promise.all(requests).then(async () => {
                await this.getUserOrGroup(firstUser.type, firstUser.id, projectId);
                this.onSelectMaster(this._usersAndGroups[0]);
            }).catch(async () => {
                const translations = await this.translatePipe.transform(['ERROR', 'UNEXPECTED_ERROR']);
                this.dialogManagerService.showErrorDialog({
                    title: translations['ERROR'],
                    text: translations['UNEXPECTED_ERROR']
                });
            });
        } else if (this._usersAndGroups && this._usersAndGroups.length === 0 && this._project) {
            this._usersAndGroups = [];
            this.roles = this.store.getState().user.roles;
            this.roles.forEach((r: any) => r.selected = false);
        }
    }

    public get usersAndGroups() {
        return this._usersAndGroups;
    }

    @Input() public set project(value: any) {
        this._project = value;
    }

    public get project() {
        return this._project;
    }

    @Input() public set dataHelper(_: any) {
    }

    public get dataHelper() {
        return this._data;
    }

    @Output() public onDelete = new EventEmitter();

    public roles: any;

    private unSubscribers: any[];
    private _usersAndGroups: any;
    private _project: any;
    private _data: any;
    public AuthType:String;
    public AuthOnlyMode:Boolean;
    private _tempPermission: any;
    private _masterSelection: any;
    private firstTime = true;
    private allUsersAndGroups: any;
    private deletedItems: any;
    public isSyncEnabled: boolean = false;

    constructor(
        private store: Store,
        private dialogManagerService: DialogManagerService,
        private translatePipe: TranslatePipe) {
    }

    public ngOnInit() {
        this.AuthType = JSON.parse(localStorage.getItem('AuthType'))
        this.AuthOnlyMode = JSON.parse(localStorage.getItem('AuthOnly'));
        let id: any;
        this.unSubscribers = [
            this.store.subscribe(() => {
                const userState = this.store.getState().user;
                if (userState.roles) {
                    this.roles = userState.roles;
                    this.roles.forEach((r: any) => r.selected = false);
                }

                if (userState.rolesData) {
                    if (userState.rolesData.id) {
                        id = userState.rolesData.id;
                    }
                    let type: any;
                    switch (userState.rolesData.type) {
                    case userActions.GET_USER_ROLES:
                    case userActions.GET_PROJECT_GROUP_ROLES:
                        type = 'user';
                        break;
                    case userActions.GET_USER_GROUP_ROLES:
                    case userActions.GET_PROJECT_GROUP_ROLES_BY_USER_GROUP:
                        type = 'userGroup';
                        break;
                    default:
                        type = 'user'; // hack no idea what the type of send as undefined!!!!
                    }

                    if (this._usersAndGroups) {
                        const userAndGroupItem = this._usersAndGroups.find((x: any) => x.id === id && x.type === type);
                        if (userAndGroupItem) {
                            userAndGroupItem.selectedRoles = userState.rolesData.selectedRoles;
                            if (this.firstTime) {
                                this._tempPermission = this.deepCopy(this._usersAndGroups);
                            }
                        }
                        if (this._masterSelection && this._masterSelection.id === id
                            && this._masterSelection.type === type) {
                            this._masterSelection.selectedRoles = userState.rolesData.selectedRoles;
                        }
                    }

                    if (this._masterSelection && this._masterSelection.selectedRoles) {
                        this._masterSelection.selectedRoles.forEach((sr: any) => {
                            const role = this.roles.find((r: any) => r.id === sr.id);
                            if (role) {
                                role.selected = true;
                            }
                        });
                    }
                }

                if (userState.allUsersAndGroups) {
                    this.allUsersAndGroups = userState.allUsersAndGroups;
                    this.allUsersAndGroups.forEach((item: any) => {
                        item.icon = types[item.type];
                    });
                }
            })
        ];
        this.store.dispatch({ type: userActions.GET_ROLES });
        this.store.dispatch({ type: userActions.GET_ALL_USERS_AND_GROUPS });
        this.deletedItems = [];
        this.store.dispatch({ type: userActions.IS_SYNC_ENABLED })
            .then((isSync) => {
                this.isSyncEnabled = isSync;
            });
    }

    public ngOnDestroy() {
        this.unSubscribers.forEach(us => us());
    }

    public save() {
        const usersAndGroupsCopy = [...this.usersAndGroups];
        const requests = [];
        let selections = [this._masterSelection];
        if (this.deletedItems.length > 0) {
            this.deletedItems.forEach((itemDel: any) => {
                itemDel.selectedRoles = null; // indication when user click on X button
                usersAndGroupsCopy.push(itemDel);
            });
            selections = [...this.deletedItems];
        }

        let userSaveAction: any;
        let groupSaveAction: any;
        if (this._project.type === 'proj') {
            userSaveAction = userActions.SAVE_USER_ROLES;
            groupSaveAction = userActions.SAVE_USER_GROUP_ROLES;
        } else {
            userSaveAction = userActions.SAVE_PROJECT_GROUP_ROLES_BY_USER;
            groupSaveAction = userActions.SAVE_PROJECT_GROUP_ROLES_BY_USER_GROUP;
        }
        selections.forEach((item) => {
            switch (item.type) {
            case 'user':
                requests.push(this.store.dispatch({
                    type: userSaveAction,
                    payload: {
                        userId: item.id,
                        projectId: this._project.id,
                        rolesData: item.selectedRoles
                    },
                    customErrorHandling: true
                }));
                break;
            case 'userGroup':
                requests.push(this.store.dispatch({
                    type: groupSaveAction,
                    payload: {
                        userGroupId: item.id,
                        projectId: this._project.id,
                        rolesData: item.selectedRoles
                    },
                    customErrorHandling: true
                }));
                break;
            }
        });
        const messages = [];
        Promise.all(requests).then(async (res) => {
            const translations = await this.translatePipe.transform([
                'SUCCESS_ACTION',
                'ERROR',
                'ERROR_ADD_USER_OR_GROUP'
            ]);
            res.forEach((response: any, index: any) => {
                if (response.status === 439) {
                    messages.push(`${usersAndGroupsCopy[index].name} - ${response.data}`);
                } else if (response.status === 401 || response.status === 403) {
                    const obj = messages.find(item => item === response.data);
                    if (!obj) {
                        messages.push(response.data);
                    }
                } else if (response.status === 400) {
                    const message = 'Please check Admin Web Service logs and make sure that the repository is available for the Admin Web Service';
                    const obj = messages.find(item => item === message);
                    if (!obj) {
                        messages.push(message);
                    }
                } else if (response.status === 500) {
                    const message = 'Please check Admin Web Service logs';
                    const obj = messages.find(item => item === response.data);
                    if (!obj) {
                        messages.push(message);
                    }
                } else if (response.status !== 200) {
                    messages.push('An unexpected error occurred. Please see logs for more details.');
                }
            });
            if (requests.length > 0 && messages.length === 0) {
                this.firstTime = true;
                this.deletedItems = [];
                // this.usersAndGroups = usersAndGroupsCopy
                //     .filter(item => item.selectedRoles && item.selectedRoles.length > 0);
                this.dialogManagerService.showSuccessDialog({ title: translations['SUCCESS_ACTION'], text: '' });
            } else {
                if (requests.length === 0) {
                    this.dialogManagerService.showErrorDialog({
                        title: translations['ERROR'],
                        text: translations['ERROR_ADD_USER_OR_GROUP']
                    });
                } else {
                    this.dialogManagerService.showErrorDialog({
                        title: translations['ERROR'],
                        text: messages.join(' and ')
                    });
                }
            }
        }).catch(async (error: any) => {
            messages.push(error);
            const translations = await this.translatePipe.transform(['ERROR', 'UNEXPECTED_ERROR']);
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: translations['UNEXPECTED_ERROR']
            });
        });
    }

    public cancel() {
        this._usersAndGroups = this._tempPermission;
        // BUG Angular 7 does not detect angular.copy
        this._tempPermission = this.deepCopy(this._usersAndGroups);
        this.firstTime = true;
    }

    public openUsersGroupsModal() {
        const availableUsersAndGroups = _.differenceBy(this.allUsersAndGroups, this._usersAndGroups, 'name');
        availableUsersAndGroups.forEach((item: any) => item.selected = false);
        this.dialogManagerService.showAddFromListDialog(
            {
                title: 'Select Users/Groups',
                placeholder: 'Search',
                contentClass: 'users-groups-popup',
                items: availableUsersAndGroups
            },
            (data) => {
                const selected = data.items.filter((x: any) => x.selected);
                selected.forEach((item: any) => {
                    this.firstTime = false;
                    this._usersAndGroups = [item, ...this._usersAndGroups];
                });
                if (selected) {
                    const selectedUserOrGroup = this._usersAndGroups[0];
                    selectedUserOrGroup.selectedRoles = [];
                    this.onSelectMaster(selectedUserOrGroup);
                    setTimeout(() => $('.permission-container .master-list li:nth-child(1)').click(), 50);
                }
            }
        );
    }

    public onSelectMaster(masterSelection: any) {
        if (masterSelection) {
            this._masterSelection = masterSelection;
            this.roles.forEach((r: any) => r.selected = false);
            if (this._project) {
                let userGetAction: any;
                let groupGetAction: any;
                if (this._project.type === 'proj') {
                    userGetAction = userActions.GET_USER_ROLES;
                    groupGetAction = userActions.GET_USER_GROUP_ROLES;
                } else {
                    userGetAction = userActions.GET_PROJECT_GROUP_ROLES;
                    groupGetAction = userActions.GET_PROJECT_GROUP_ROLES_BY_USER_GROUP;
                }
                switch (this._masterSelection.type) {
                case 'user':
                    this.store.dispatch({
                        type: userGetAction,
                        payload: { userId: this._masterSelection.id, projectId: this._project.id }
                    });
                    break;
                case 'userGroup':
                    this.store.dispatch({
                        type: groupGetAction,
                        payload: { userGroupId: this._masterSelection.id, projectId: this._project.id }
                    });
                    break;
                }
            }

            if (this._masterSelection.selectedRoles) {
                this._masterSelection.selectedRoles.forEach((sr: any) => {
                    this.roles.find((r: any) => r.id === sr.id).selected = true;
                });
            }
        } else {
            this.roles.forEach((r: any) => r.selected = false);
        }
    }

    public onDetailsListChanged() {
        this.firstTime = false;
        const selectedRoles = this.roles.filter((x: any) => x.selected);
        // hook for global admin
        _.each(selectedRoles, (role: any) => {
            if (role.id === 1) {
                role.selected = true;
            }
        });
        if (this._masterSelection) {
            this._masterSelection.selectedRoles = selectedRoles;
        }
    }

    public onItemRemove(item: any) {
        window.event.cancelBubble = true;
        this.firstTime = false;
        const itemIndex = this._usersAndGroups.findIndex((x: any) => x.id === item.id && x.type === item.type);
        if (itemIndex !== -1) {
            const onConfirm = () => {
                this.deletedItems.push(this._usersAndGroups[itemIndex]);
                this._usersAndGroups.splice(itemIndex, 1);
                if (this._masterSelection && item.type === this._masterSelection.type
                    && item.id === this._masterSelection.id) {
                    this._masterSelection = this._usersAndGroups[itemIndex];
                    this.onSelectMaster(this._masterSelection);
                }
                this.save();
            };
            const itemName = this._usersAndGroups[itemIndex].name;
            const dialogData = { title: 'Removal of User/Group', action: 'delete', item: itemName };
            this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
        }
    }

    private async getUserOrGroup(type: any, id: any, projectId: any) {
        switch (type) {
        case 'user':
            await this.store.dispatch({
                type: this._project.type === 'proj'
                    ? userActions.GET_USER_ROLES : userActions.GET_PROJECT_GROUP_ROLES,
                payload: { projectId, userId: id }
            });
            break;
        case 'userGroup':
            await this.store.dispatch({
                type: this._project.type === 'proj'
                    ? userActions.GET_USER_GROUP_ROLES : userActions.GET_PROJECT_GROUP_ROLES_BY_USER_GROUP,
                payload: { projectId, userGroupId: id }
            });
            break;
        }
    }

    private deepCopy(obj: any) {
        if (!obj) {
            return obj;
        }

        return _.cloneDeep(obj);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/project-management/project-permission/project-permission.component.ts